export const GET_COMMUNITY_DATA = "GET_COMMUNITY_DATA";
export const GET_RESOURCE_CMS_DATA = "GET_RESOURCE_CMS_DATA";
export const GET_UPCOMING_FEATURE_CMS_DATA = "GET_UPCOMING_FEATURE_CMS_DATA";
export const GET_TERMS_CMS_DATA = "GET_TERMS_CMS_DATA";
export const GET_BAA_CMS_DATA = "GET_BAA_CMS_DATA";
export const GET_PRIVACY_CMS_DATA = "GET_PRIVACY_CMS_DATA";
export const GET_INSURANCE_CMS_DATA = "GET_INSURANCE_CMS_DATA";
export const GET_MEMBERSHIP_CMS_DATA = "GET_MEMBERSHIP_CMS_DATA";
export const GET_HOW_IT_WORKS_CMS_DATA = "GET_HOW_IT_WORKS_CMS_DATA";
export const GET_ABOUT_CMS_DATA = "GET_ABOUT_CMS_DATA";
export const GET_INSURANCE_DETAILS = "GET_INSURANCE_DETAILS";
export const GET_ABOUT_DATA = "GET_ABOUT_DATA";
export const GET_FAQ_CMS_DATA = "GET_FAQ_CMS_DATA";
export const GET_MEBEBER_BENEFITS_CMS_DATA = "GET_MEBEBER_BENEFITS_CMS_DATA";
export const GET_SECURITY_DATA = "GET_SECURITY_DATA";
